import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail, HiOutlineLocationMarker } from "react-icons/hi";

const Contact = () => {
  const contacts = [
    {
      label: "Email",
      value: "rpal778866@gmail.com",
      href: "mailto:rpal778866@gmail.com",
      icon: <HiOutlineMail size={22} />,
    },
    {
      label: "LinkedIn",
      value: "raj-pal-a052211b5",
      href: "https://www.linkedin.com/in/raj-pal-a052211b5/",
      icon: <FaLinkedin size={22} />,
    },
    {
      label: "GitHub",
      value: "Raj-Stark",
      href: "https://github.com/Raj-Stark",
      icon: <FaGithub size={22} />,
    },
    {
      label: "Location",
      value: "Noida, Uttar Pradesh, India",
      icon: <HiOutlineLocationMarker size={22} />,
    },
  ];

  return (
    <footer
      name="contact"
      className="border-t border-white/10 bg-[#080b0d] px-5 py-20 text-white lg:px-8"
    >
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr]">
          <div>
            <p className="text-sm font-extrabold uppercase tracking-[0.18em] text-emerald-300">
              Contact
            </p>
            <h2 className="mt-4 text-3xl font-extrabold leading-tight sm:text-5xl">
              Available for software and product engineering opportunities.
            </h2>
            <p className="mt-5 text-lg leading-8 text-zinc-400">
              I build frontend-heavy, backend-connected product features for
              SaaS dashboards, HRMS/payroll workflows, automation tools, and
              growth-focused web products.
            </p>

            <div className="mt-8 grid gap-3 sm:grid-cols-2">
              {contacts.map(({ label, value, href, icon }) => {
                const content = (
                  <>
                    <span className="rounded-md bg-emerald-400/10 p-3 text-emerald-300">
                      {icon}
                    </span>
                    <span className="min-w-0">
                      <span className="block text-xs font-bold uppercase tracking-[0.14em] text-zinc-500">
                        {label}
                      </span>
                      <span className="block break-words font-semibold text-zinc-100">
                        {value}
                      </span>
                    </span>
                  </>
                );

                return href ? (
                  <a
                    key={label}
                    href={href}
                    target={href.startsWith("mailto:") ? undefined : "_blank"}
                    rel={href.startsWith("mailto:") ? undefined : "noreferrer"}
                    className="flex min-w-0 items-center gap-4 rounded-md border border-white/10 bg-white/[0.04] p-4 transition hover:border-emerald-300/50"
                  >
                    {content}
                  </a>
                ) : (
                  <div
                    key={label}
                    className="flex min-w-0 items-center gap-4 rounded-md border border-white/10 bg-white/[0.04] p-4"
                  >
                    {content}
                  </div>
                );
              })}
            </div>
          </div>

          <form
            action="https://getform.io/f/d9e55eae-c0de-4aad-b890-96d485d14747"
            method="POST"
            className="rounded-md border border-white/10 bg-[#111719] p-6 text-white shadow-2xl shadow-black/30"
          >
            <div className="grid gap-4 sm:grid-cols-2">
              <label className="block">
                <span className="text-sm font-bold text-zinc-300">Name</span>
                <input
                  type="text"
                  name="name"
                  placeholder="Your name"
                  className="mt-2 w-full rounded-md border border-white/10 bg-[#080b0d] px-4 py-3 text-white outline-none transition placeholder:text-zinc-600 focus:border-emerald-300"
                />
              </label>
              <label className="block">
                <span className="text-sm font-bold text-zinc-300">Email</span>
                <input
                  type="email"
                  name="email"
                  placeholder="you@company.com"
                  className="mt-2 w-full rounded-md border border-white/10 bg-[#080b0d] px-4 py-3 text-white outline-none transition placeholder:text-zinc-600 focus:border-emerald-300"
                />
              </label>
            </div>

            <label className="mt-5 block">
              <span className="text-sm font-bold text-zinc-300">Message</span>
              <textarea
                name="message"
                placeholder="Tell me about the role, product, or project"
                rows="8"
                className="mt-2 w-full rounded-md border border-white/10 bg-[#080b0d] px-4 py-3 text-white outline-none transition placeholder:text-zinc-600 focus:border-emerald-300"
              ></textarea>
            </label>

            <button className="mt-6 w-full rounded-md bg-emerald-400 px-6 py-3 text-base font-extrabold text-[#080b0d] transition hover:bg-emerald-300">
              Send Message
            </button>
          </form>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 text-sm font-semibold text-zinc-500 sm:flex-row sm:items-center sm:justify-between">
          <p>Raj - Software Engineer</p>
          <p>React.js - Next.js - TypeScript - Product Engineering</p>
        </div>
      </div>
    </footer>
  );
};

export default Contact;
